import uniqBy from "lodash/uniqBy";

import * as types from '../actions/actionTypes';
import {isSameVisualizerWizard} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {getCommonVisualizerType, IS_LIXIL_UI} from "../config";

const initialState = {
  wizardIsActive: false, // is used on the materials page instead of the quotingtool
  wizardIsActiveObject: [], // is used for visualizer switching {"kvScene": false, "bvLook": true}
  wizardConfig: [], // arrayOf wizardObjectInterface // this is not used for now, it is a regular quoting tool filters wizard
// {
//   id: 1,
//     name: "Count wiz",
//   description: "some desc",
//   enableForVisualizer: false,
//   enableForQuoting: true,
//   featureGroupName: "Countertop", // empty input case
//   isFinished: false, // frontend property
//   filterGroups: [
//   {
//     id: 43,
//     name: "Countertop Material",
//     type: "Single",
//     values: [],
//     visualType: "ListWithCheckBoxes"
//   },
//   {
//     id: 35,
//     name: "Manufacturer ",
//     type: "Single",
//     values: [],
//     visualType: "ImageList",
//   },
//   {
//     id: 15,
//     name: "Stone Color",
//     type: "Single",
//     values: [],
//     visualType: "ColorsWithColumns"
//   },
// ]
// }
  // wizardActiveFilterGroupIndex: 0
  wizardList: [],
  wizardActiveItem: null,
  // wizardActiveStep: 0, // was -1 do not show the welcome screen on QKB and Lixil too
  wizardActiveStep: IS_LIXIL_UI ? -1 : 0, // do not show the welcome screen on QKB // reverted per solid surface request
  wizardSelectedValues: {},
  allWizardsValues: [], // [wizardAllObjectInterface]
  wizardShowFeatureSection: null,
  wizardMissingFeatures: {}, // "1-18": ["10", "20", ...]
  wizardWasRestored: false, // for complete popup
  wizardConflictingSteps: [], // we need to show the flow was changed popup, {wizardConflictingObjectInterface}
  wizardConflictPopupOpened: false,
  wizardConflictPopupCallback: null,
  wizardSqftCartItems: [], // we can't set cart items directly, but we need to set them in wizard
  wizardAllowSkipDoneSteps: true,
};

export const getUpdatedAllWizardValues = (state, quoteIndex, wizardItemId, wizardSelectedValues) => {
  const newWizObject = {
    quoteIndex,
    wizardItemId,
    lastVisitedStep: state.wizardActiveStep,
    visualizer: getCommonVisualizerType(),
    wizardSelectedValues: Object.assign({}, wizardSelectedValues)
  };
  const existingIndex = state.allWizardsValues.findIndex(wizSelObject => {
    return wizSelObject.wizardItemId === newWizObject.wizardItemId
      && (wizSelObject.quoteIndex === newWizObject.quoteIndex) && isSameVisualizerWizard(wizSelObject)
  });
  existingIndex > -1
    ? state.allWizardsValues.splice(existingIndex, 1, newWizObject)
    : state.allWizardsValues.push(newWizObject);

  state.allWizardsValues = state.allWizardsValues.map(wizObject => {
    if (wizObject.quoteIndex === quoteIndex && isSameVisualizerWizard(wizObject)) {
      wizObject.isLastActiveWizard = wizObject.wizardItemId === wizardItemId // to return back and force correctly
    }
    return wizObject
  });

  return [...state.allWizardsValues]
}

export default function(state = initialState, action) {

  switch(action.type) {

    case types.SET_WIZARD_IS_ACTIVE: {
      const newState = Object.assign({}, state, {wizardIsActive: action.payload.wizardIsActive});
      if (action.payload.visualizerType && !state.wizardIsActiveObject[action.payload.visualizerType]) {
        newState.wizardIsActiveObject = {
          ...state.wizardIsActiveObject,
          [action.payload.visualizerType]: action.payload.wizardIsActive
        }
      }
      return newState;
    }
    case types.SET_WIZARD_ACTIVE_FILTER_GROUP_INDEX: // NOT USED!
    case types.SET_WIZARD_CONFIG:
    case types.SET_WIZARD_SHOW_FEATURE_SECTION:
    case types.RESTORE_ALL_WIZARD_SELECTED_VALUES:
    case types.SET_WIZARD_CONFLICT_POPUP_OPENED:
    case types.SET_WIZARD_SQFT_CART_ITEMS:
    case types.SET_WIZARD_CONFLICT_STEPS:
    case types.SET_WIZARD_ALLOW_SKIP_DONE_STEPS:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_WIZARD_LIST:
      return Object.assign({}, state, {
        wizardList: uniqBy([...state.wizardList, ...action.payload.wizardList], wizItem => wizItem.id)
      });
    case types.SET_WIZARD_ACTIVE_ITEM:
      if (action.payload.wizardActiveItem) {
        const alreadySelectedWizard = state.allWizardsValues.find(wizard => {
          return wizard.wizardItemId === action.payload.wizardActiveItem.id && (wizard.quoteIndex === action.payload.quoteIndex)
        });
        if (alreadySelectedWizard) {
          action.payload.wizardSelectedValues = Object.assign({}, alreadySelectedWizard.wizardSelectedValues); // restore added data
          action.payload.wizardActiveStep = Number.isInteger(alreadySelectedWizard.lastVisitedStep)
              ? alreadySelectedWizard.lastVisitedStep // restore last step
              : Object.keys(alreadySelectedWizard.wizardSelectedValues).length // restore last step (just in case lastVisitedStep is missing)
          action.payload.wizardWasRestored = true // for complete popup
        } else if ((state.wizardActiveStep === -1) && action.payload.wizardActiveItem.skipStartStep) {
          action.payload.wizardActiveStep = 0;
        }
        action.payload.allWizardsValues = state.allWizardsValues.map(wizObject => {
          if (wizObject.quoteIndex === action.payload.quoteIndex && isSameVisualizerWizard(wizObject)) {
            wizObject.isLastActiveWizard = wizObject.wizardItemId === action.payload.wizardActiveItem.id // to return back and force correctly
          }
          return wizObject
        })
      }
      return Object.assign({}, state, {
        ...action.payload,
      });
    case types.SET_WIZARD_ACTIVE_STEP: {
      return Object.assign({}, state, {
        wizardActiveStep: action.payload.wizardActiveStep,
        wizardSelectedValues: action.payload.wizardSelectedValues,
        wizardConflictingSteps: action.payload.wizardConflictingSteps,
        wizardWasRestored: false,
        wizardAllowSkipDoneSteps: action.payload.wizardActiveStep < state.wizardActiveStep
          ? false
          : state.wizardAllowSkipDoneSteps,
      });
    }
    case types.SET_WIZARD_SELECTED_VALUES: {
      if (action.payload.allWizardsValues) {
        return Object.assign({}, state, {
          allWizardsValues: action.payload.allWizardsValues,
          wizardSelectedValues: action.payload.wizardSelectedValues,
          wizardConflictingSteps: action.payload.wizardConflictingSteps
        });
      }
      return Object.assign({}, state, {
        wizardSelectedValues: action.payload.wizardSelectedValues,
        wizardConflictingSteps: action.payload.wizardConflictingSteps
      });
    }
    case types.SET_WIZARD_MISSING_FEATURES: {
      const wizardMissingFeatures = {
        ...state.wizardMissingFeatures,
        [action.payload.wizardMissingKey]: action.payload.wizardMissingFeatures
      }
      return Object.assign({}, state, {wizardMissingFeatures});
    }
    case types.SET_ALL_WIZARD_SELECTED_VALUES: {
      const {wizardSelectedValues, quoteIndex, wizardItemId} = action.payload;
      const existingAllObject = state.allWizardsValues.find(wizSelObject => {
        return wizSelObject.wizardItemId === wizardItemId && wizSelObject.quoteIndex === quoteIndex
      });
      const existingValues = existingAllObject ? existingAllObject.wizardSelectedValues : {};
      const updatedValues = Object.assign({}, existingValues, wizardSelectedValues)
      const allWizardsValues = getUpdatedAllWizardValues(state, quoteIndex, wizardItemId, updatedValues);
      return Object.assign({}, state,  {allWizardsValues});
    }
    case types.SET_LOOK_OPENED:
      if (!action.payload.lookOpened && state.wizardActiveItem) {
        return Object.assign({}, state, { wizardActiveItem: null });
      }
      break;
  }

  return state;

}
